import PropTypes from "prop-types";
import React from "react";

import Icon from "../interface/Icon";

const DrawerItem = props => (
  <div>
    <div className={`drawerItem ${props.active ? "active" : ""}`} onClick={props.onClick} title={props.label}>
      <div className="drawerItemTitle">
        {props.icon ? (
          <svg className="icon">
            <use xlinkHref={"#" + props.icon} />
          </svg>
        ) : null}
        <span className="tabLabel">{props.label}</span>
        {props.badge ? <span className={`badge ${props.badgeColor}`}>{props.badge}</span> : null}
        {props.showArrow ? <Icon className="rightArrow" icon="rightArrow" color="mono" /> : null}
      </div>
      <div className="drawerItemPreview">{props.preview}</div>
    </div>
  </div>
);

DrawerItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string,
  badge: PropTypes.number,
  badgeColor: PropTypes.string,
  label: PropTypes.string.isRequired,
  showArrow: PropTypes.bool,
  active: PropTypes.bool.isRequired,
  preview: PropTypes.element
};

export default DrawerItem;
